import axios from "axios";

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL + "/api", // مثلاً /api/auth/login
  headers: {
    "Content-Type": "application/json",
  },
  withCredentials: true, // اگر از کوکی استفاده می‌کنی
});
axiosInstance.interceptors.request.use((config) => {
  const fullUrl = `${config.baseURL || ""}${config.url}`;
  console.log("🌐 [Axios] Request URL:", fullUrl);
  console.log("📦 [Axios] Payload:", config.data);
  return config;
});
axiosInstance.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  console.log("token", token);
  if (token) {
    config.headers["Authorization"] = `Bearer ${token}`;
  } else {
    console.warn("🔒 هیچ توکنی موجود نیست! احتمالاً کاربر لاگین نیست.");
    // اگر خواستی اینجا می‌تونی خطا بدی یا به صفحه لاگین هدایت کنی
    // window.location.href = "/login"; ← خطرناک در همه درخواست‌ها
  }

  return config;
});
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      console.warn("🛑 دسترسی غیرمجاز! احتمالاً توکن نامعتبر یا منقضی شده.");
      // پاک کردن توکن و هدایت به لاگین
      localStorage.removeItem("token");
      window.location.href = "/login"; // یا استفاده از navigate
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
